import { string as YupString } from 'yup';

export default {
  newPasswordValidation: ({ minLengthMessage, minOneNumberMessage, minOneLetterMessage }) => {
    return YupString()
      .trim()
      .min(8, minLengthMessage)
      .matches(new RegExp(/\d+/i), minOneNumberMessage)
      .matches(new RegExp(/[A-z]+/i), minOneLetterMessage)
      .strict(true);
  },
  emailValidation: ({ emptyEmailMessage, invalidEmailMessage, maxLengthMessage }) => {
    return YupString()
      .trim()
      .required(emptyEmailMessage)
      .matches(
        /* eslint-disable */
        new RegExp(
          /^(?:[a-z0-9!#$%&'*+/=?^_\x60{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_\x60{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i
        ),
        { message: invalidEmailMessage, excludeEmptyString: true }
        /* eslint-enable */
      )
      .max(64, maxLengthMessage);
  },
  contactNumberValidation: ({ invalidContactNumberMessage }) => {
    return YupString()
      .trim()
      .matches(
        new RegExp(/^(?:8(?:[0-8]\d\d|9(?:[014]\d|2[1-9]|3[0-489]|5[0-2]))|9[0-8]\d\d)\d{4}$/i),
        invalidContactNumberMessage
      );
  },
};
